<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 7/9/20
-->

<template>
	<div class="context-menu-root">
		<div v-for="(menuItem, index) in menuItems" :key="index"
			 class="hover clickable">
			<hr v-if="menuItem.isDivided" class="my-1"/>
<!--			<div class="py-2 px-3" :class="menuItem.menuItemClass">-->
			<div>
				<div v-if="isLinkRow(menuItem)" class="qw-row" :class="menuItemClass(menuItem)">
					<i v-if="menuItem.icon"
					   :class="['fontello', menuItem.icon, 'pr-3']"
					   style="font-size: 16px"/><a :href="menuItem.href" target="_blank">{{menuItem.name}}</a>
				</div>
				<div v-else-if="isSwitchRow(menuItem)" class="qw-row" :class="menuItemClass(menuItem)" @click="onSwitchChanged(menuItem)">
					<div class="layout-spacer">{{menuItem.name}}</div>
					<el-switch v-model="menuItem.isSwitchedOn" :disabled="true"/>
				</div>
				<div v-else @click.stop="onClick(menuItem)" :class="menuItemClass(menuItem)">
					<QwIcon
						v-if="menuItem.icon || menuItem.iconImage"
						:icon="menuItem.icon"
						:iconImage="menuItem.iconImage"
						:iconImageWidth="menuItem.iconImageWidth"
						class="mr-3"
						style="font-size: 1rem"
					/>{{menuItem.name}}
				</div>
			</div>
		</div>
	</div>

</template>

<script>

	import SwitchMenuItem from "@/core/modules/coach/Resources/Files/QwoachDrive/SwitchMenuItem";
	import LinkMenuItem from "@/core/modules/coach/Resources/Files/QwoachDrive/LinkMenuItem";
	import QwIcon from "@/core/components/QwIcon.vue";

	export default {
		name: "ContextMenu",
		components: {QwIcon},
		component: {},
		props:{
			menuItems:{type: Array, default: () => []},
		},

		methods: {

			onSwitchChanged(menuItem){
				menuItem.isSwitchedOn = !menuItem.isSwitchedOn;
				this.onClick(menuItem, {keepMenuPopup: true, isSwitchedOn: menuItem.isSwitchedOn})
			},

			onClick(menuItem, options) {
				this.$emit("click", menuItem.action, options)
			},

			isSwitchRow(menuItem){
				return menuItem instanceof SwitchMenuItem
			},

			isLinkRow(menuItem){
				return menuItem instanceof LinkMenuItem
			},

			menuItemClass(menuItem) {
				return `px-4 py-2_5 ${menuItem.menuItemClass || ""}`
			}

		},

		computed: {
		},
	}
</script>

<style lang="scss">

	.context-menu-root{
		.el-switch.is-disabled{
			opacity: 1;

			.el-switch__core{
				cursor: inherit;
			}
		}
	}

</style>
